
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import {
  Separator,
  Panel,
  PanelBody,
  PanelSection,
  Margin,
  Size,
  Flex,
  FlexItem,
  FlexJustify,
  Label,
  Toggle,
} from '@drawbotics/react-drylus';
import Playground from '~/components/Playground';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


<h1>{`Separator`}</h1>
<p>{`Simply a decorative component used to add a thin grey bar between contents in a page or other container. If you want to add spacing you should use the `}<inlineCode parentName="p">{`Margin`}</inlineCode>{` and `}<inlineCode parentName="p">{`Padding`}</inlineCode>{` components.`}</p>
<pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Separator } from '@drawbotics/react-drylus';
`}</code></pre>
<p><strong parentName="p">{`Example`}</strong></p>
<Playground __position={0} __code={`<div style={{ height: 100 }}>
  <Separator />
</div>`} component={Separator} mdxType="Playground">
  <div style={{
        height: 100
      }}>
    <Separator mdxType="Separator" />
  </div>
</Playground>
<h3>{`Example in panel`}</h3>
<Playground __position={1} __code={`<div style={{ maxWidth: 400 }}>
  <Panel
    body={
      <PanelBody>
        <PanelSection title="Actions">
          <Margin size={{ bottom: Size.SMALL }}>
            <Flex justify={FlexJustify.SPACE_BETWEEN}>
              <FlexItem>
                <Label>First thing</Label>
              </FlexItem>
              <FlexItem>
                <Toggle value={true} onChange={x=>x} size={Size.SMALL} />
              </FlexItem>
            </Flex>
          </Margin>
          <Separator />
          <Margin size={{ top: Size.SMALL, bottom: Size.SMALL }}>
            <Flex justify={FlexJustify.SPACE_BETWEEN}>
              <FlexItem>
                <Label>Second thing</Label>
              </FlexItem>
              <FlexItem>
                <Toggle value={false} onChange={x=>x} size={Size.SMALL} />
              </FlexItem>
            </Flex>
          </Margin>
          <Separator />
          <Margin size={{ top: Size.SMALL }}>
            <Flex justify={FlexJustify.SPACE_BETWEEN}>
              <FlexItem>
                <Label>Third thing</Label>
              </FlexItem>
              <FlexItem>
                <Toggle value={true} onChange={x=>x} size={Size.SMALL} />
              </FlexItem>
            </Flex>
          </Margin>
        </PanelSection>
      </PanelBody>
    } />
</div>`} mdxType="Playground">
  <div style={{
        maxWidth: 400
      }}>
    <Panel body={<PanelBody mdxType="PanelBody">
          <PanelSection title="Actions" mdxType="PanelSection">
            <Margin size={{
              bottom: Size.SMALL
            }} mdxType="Margin">
              <Flex justify={FlexJustify.SPACE_BETWEEN} mdxType="Flex">
                <FlexItem mdxType="FlexItem">
                  <Label mdxType="Label">First thing</Label>
                </FlexItem>
                <FlexItem mdxType="FlexItem">
                  <Toggle value={true} onChange={x => x} size={Size.SMALL} mdxType="Toggle" />
                </FlexItem>
              </Flex>
            </Margin>
            <Separator mdxType="Separator" />
            <Margin size={{
              top: Size.SMALL,
              bottom: Size.SMALL
            }} mdxType="Margin">
              <Flex justify={FlexJustify.SPACE_BETWEEN} mdxType="Flex">
                <FlexItem mdxType="FlexItem">
                  <Label mdxType="Label">Second thing</Label>
                </FlexItem>
                <FlexItem mdxType="FlexItem">
                  <Toggle value={false} onChange={x => x} size={Size.SMALL} mdxType="Toggle" />
                </FlexItem>
              </Flex>
            </Margin>
            <Separator mdxType="Separator" />
            <Margin size={{
              top: Size.SMALL
            }} mdxType="Margin">
              <Flex justify={FlexJustify.SPACE_BETWEEN} mdxType="Flex">
                <FlexItem mdxType="FlexItem">
                  <Label mdxType="Label">Third thing</Label>
                </FlexItem>
                <FlexItem mdxType="FlexItem">
                  <Toggle value={true} onChange={x => x} size={Size.SMALL} mdxType="Toggle" />
                </FlexItem>
              </Flex>
            </Margin>
          </PanelSection>
        </PanelBody>} mdxType="Panel" />
  </div>
</Playground>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;